import React,{StrictMode} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {HashRouter} from "react-router-dom";
import '../../lang/index';
import '../../css/animate.css';
import '../../css/icon.css';
import '../../tailwind.css';
import GetDomain from "../../publicComponent/GetDomain";
// console.log(process.env.mall,'mall');
ReactDOM.render(
  <StrictMode>
    <HashRouter>
      <GetDomain mall={9}>
        <App/>
      </GetDomain>
    </HashRouter>
  </StrictMode>,
  document.getElementById('root')
);

